import moment from 'moment'

import { leaveEmployee } from 'modules/timeoff/lib/leaveEmployees'
import allowanceStats from 'modules/timeoff/store/collections/stats'
import policyTimelines from 'modules/timeoff/store/collections/timeoffPolicies/policyTimelines'

import allowances from '../store/collections/allowances'
import type Allowance from '../store/models/Allowance'
import type Leave from '../store/models/Leave'
import { PolicyTimelineItem } from '../store/models/TimeoffPolicy/PolicyTimeline'

interface EffectiveAllowance {
  allowance: Allowance | undefined
  timelineItem: PolicyTimelineItem | undefined
}

const leaveEffectiveAllowance = (leave: Leave): EffectiveAllowance => {
  const timeline = policyTimelines.timeline
  const timelineItem = timeline?.items.find((item) =>
    moment(item.start_at).isSameOrBefore(leave.startOn)
  )

  const allowance = timelineItem
    ? allowances
        .filter((a) => a.attributes.timeoff_policy_id === timelineItem.timeoff_policy_id)
        .find((a) => a.attributes.leave_type_ids.includes(leave.attributes.leave_type_id))
    : undefined

  return { allowance, timelineItem }
}

const fetchStats = (leave: Leave) => {
  if (!leave) return Promise.resolve()

  const employee = leaveEmployee(leave)
  const { allowance, timelineItem } = leaveEffectiveAllowance(leave)
  if (!allowance || !employee) return Promise.resolve()

  const allowanceStat = timelineItem
    ? allowanceStats.findOrInitializeBy(employee, allowance, timelineItem.endAt)
    : null

  return allowanceStat ? allowanceStat.fetch() : Promise.resolve()
}

interface ReturnType {
  fetchStats: (leave: Leave) => Promise<unknown>
}

const useFetchStats = (): ReturnType => {
  return {
    fetchStats,
  }
}

export default useFetchStats
